export const contactLinks = [
    {
        label: 'Inquiries',
        link: 'molarvy@gmail.com',
        displayText: 'contact.molarvy@gmail.com',
    },
    {
        label: 'X',
        link: 'https://x.com/MolarvyStudio',
        displayText: 'x.com/MolarvyStudio',
    },
    {
        label: 'Facebook',
        link: 'https://www.facebook.com/profile.php?id=61579850623704',
        displayText: 'https://www.facebook.com/profile.php?id=61579850623704',
    },
    {
        label: 'Web',
        link: 'https://www.molarvy-studio.com',
        displayText: 'https://www.molarvy-studio.com',
    },
];
